import { useSelector } from 'react-redux'

export const useMe = () => useSelector((state: $TSFixMe) => state.settings.user)
